import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import { Button } from 'remote-com-shared/components/Button';
import { Hero } from 'remote-com-shared/components/Hero';
import { Overlay, Description } from 'remote-com-shared/components/Hero/styles';
import { TwoStepFormModalButton } from 'remote-com-shared/components/TwoStepForm';
import styled, { css } from 'styled-components';

import { transformProperties } from '@/src/domains/prismic/helpers';

const HeroWrapper = styled(Hero)`
  ${({ $backgroundImage }) =>
    $backgroundImage &&
    css`
      background: url('${$backgroundImage.url}');
      background-size: cover;
    `};

  ${Overlay} {
    background-color: rgba(8, 4, 36, 0.5);
  }

  ${Description} {
    color: var(--colors-blank);
    max-width: 680px;
  }
`;

const FlagWrapper = styled.div`
  margin-bottom: 20px;
`;

export function HeroSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { label, title, description, ctaLabel, ctaLink, bgImage, flag } = primary;

  return (
    <>
      <HeroWrapper
        $backgroundImage={bgImage}
        {...(label ? { label } : {})}
        title={<PrismicRichText field={title} />}
        description={<PrismicRichText field={description} />}
        overlay
        actions={
          <>
            {ctaLabel &&
              (ctaLink ? (
                <Button href={ctaLink?.url} target={ctaLink?.target}>
                  {ctaLabel}
                </Button>
              ) : (
                <TwoStepFormModalButton>{ctaLabel}</TwoStepFormModalButton>
              ))}
          </>
        }
        countryFlag={
          flag && (
            <FlagWrapper>
              <Image src={flag?.url} alt={flag?.alt || ''} width="52" height="34" quality="100" />
            </FlagWrapper>
          )
        }
        preview="0vh"
      />
    </>
  );
}
